import React from 'react';

function LoadingPage() {
  return <div>LoadingPage</div>;
}

export default LoadingPage;
